import {
  getProductByValue,
  getAllProducts,
  updateProduct as update,
} from '../../api/productFirebase';

// FIXME export in constants.js
export const Types = {
  LOAD: 'stock/LOAD',
  SEARCH: 'stock/SEARCH',
  SEARCH_ALL: 'stock/SEARCH_ALL',
  ERROR: 'stock/ERROR',
  UPDATE: 'stock/UPDATE',
}

const INITIAL_STATE = {
  type: null,
  data: null,
  loading: false,
  error: null,
};

export default function stocks(state = INITIAL_STATE, action) {
  switch (action.type) {
    case Types.ERROR: {
      return {
        ...state,
        loading: false,
        error: action.payload
      }
    }
    case Types.LOAD: {
      return { ...state, loading: true };
    }
    case Types.SEARCH: {
      return {
        ...state,
        type: action.type,
        data: action.payload,
        loading: false,
        error: false,
      }
    }
    case Types.SEARCH_ALL: {
      return {
        ...state,
        type: action.type,
        data: action.payload,
        loading: false,
        error: false,
      }
    }
    case Types.UPDATE: {
      return {
        ...state,
        type: action.type,
        data: action.payload,
        loading: false,
        error: false,
      }
    }
    default:
      return state;
  }
}

const errorProduct = (data) => {
  return {
    type: Types.ERROR,
    payload: data
  }
}

const getProductList = (data) => {
  return {
    type: Types.SEARCH_ALL,
    payload: data
  }
}

const getProduct = (data) => {
  return {
    type: Types.SEARCH,
    payload: data.result
  }
}

const loading = () => {
  return {
    type: Types.LOAD,
  };
}

const updateStock = (data) => {
  return {
    type: Types.UPDATE,
    payload: data
  }
}

export const Creators = {
  getProduct: (name) => {
    return (dispatch) => {
      dispatch(loading());
      getProductByValue(name, (res) => {
        dispatch(getProduct(res));
      });
    };
  },

  getProductList: function () {
    return (dispatch) => {
      dispatch(loading());
      getAllProducts((res) => {
        dispatch(getProductList(res));
      });
    };
  },

  updateProduct: (value, product) => {
    const numberValue = parseInt(value);
    const prod = { ...product, estoque_atual: numberValue }

    return (dispatch) => {
      dispatch(loading());
      update(prod.Id, prod)
        .then((res) => {
          dispatch(updateStock(res));
        })
        .catch((error) => {
          dispatch(errorProduct(error));
        })
    };
  },
}
